import React from 'react';
import {FormControl, InputLabel} from '@mui/material'; // Removed alpha, InputBase, styled
import {CommonProps} from "./FormControlFactory";
import {BootstrapInput} from "../../shared/form_controls/BootstrapInput"; // Import the shared component

export interface SingleLineTextEditorProps extends CommonProps {
    elementKey: string;
    label: string;
    value: string;
    maxChars: number;
    onChange: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>, key: string) => void;
}

// REMOVED LOCAL DEFINITION
// export const BootstrapInput = styled(InputBase)(({theme}) => ({ ... }));

const SingleLineTextEditor: React.FC<SingleLineTextEditorProps> = ({
                                                                       elementKey,
                                                                       label,
                                                                       value,
                                                                       onChange,
                                                                       maxChars
                                                                   }) => {
    return (
        <FormControl fullWidth sx={{mb: 3}}>
            <InputLabel sx={{
                color: '#C3F3FD',
                left: "-13px"
            }} shrink htmlFor={`${elementKey}-input`}>
                {`${label} (${value?.length ?? 0}/${maxChars})`}
            </InputLabel>
            <BootstrapInput
                id={`${elementKey}-input`}
                // variant="outlined" // BootstrapInput doesn't have variant prop
                fullWidth
                value={value}
                placeholder={label}
                inputProps={{
                    maxLength: maxChars
                }}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event, elementKey)}
            />
        </FormControl>
    );
};


export default SingleLineTextEditor;
